import httpClient from '@xto10x/core/lib/httpClient';
import config from 'utils/config';

const openAiApis = {
  getAiSuggestedOkr: (requestBody, headers) =>
    httpClient.post(
      `${config.openaiApiRootUrl}/suggest-objective`,
      requestBody,
      null,
      headers
    ),
  getKrSuggestionBasedOnApi: (requestBody, headers) =>
    httpClient.post(
      `${config.openaiApiRootUrl}/list-krs`,
      requestBody,
      null,
      headers
    )
};

export default openAiApis;
